import { pendoConstants } from "./pendo.constants";

export const pendoActions = {
	init,
};

function init(profileData) {
	return {
		type: pendoConstants.INIT,
		data: profileData,
	};
}
